import React, { useState } from 'react';
import EmpresaList from '../components/EmpresaList';
import EmpresaForm from '../components/EmpresaForm';
import { Container, Typography, Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { actionButtonSx, pageTitleSx } from '../styles/uiTokens';
import { useAuth } from '../context/AuthContext';

function EmpresasPage() {
  const { user } = useAuth();
  const [refreshList, setRefreshList] = useState(false);
  const [editingEmpresa, setEditingEmpresa] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleEmpresaAdded = () => {
    setRefreshList(prev => !prev);
    setEditingEmpresa(null);
    setShowForm(false); // Esconde o formulario apos adicionar/atualizar
  };

  const handleEditEmpresa = (empresa) => {
    setEditingEmpresa(empresa);
    setShowForm(true); // Mostra o formulario para edicao
  };

  const handleCancelEditEmpresa = () => {
    setEditingEmpresa(null);
    setShowForm(false); // Esconde o formulario ao cancelar
  };

  const handleEmpresaDeleted = () => {
    setRefreshList(prev => !prev);
  };

  const handleShowForm = () => {
    setEditingEmpresa(null); // Garante que o formulario esta em modo de criacao
    setShowForm(true);
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" gutterBottom sx={pageTitleSx}>
          Gerenciar Empresas
        </Typography>
        {!showForm && user?.tipo_usuario === 'admin' && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleShowForm}
            sx={actionButtonSx}
          >
            Adicionar Empresa
          </Button>
        )}
      </Box>

      {showForm && (
        <EmpresaForm
          onEmpresaAdded={handleEmpresaAdded}
          initialData={editingEmpresa}
          onCancelEdit={handleCancelEditEmpresa}
        />
      )}

      {!showForm && (
        <EmpresaList
          refresh={refreshList}
          onEdit={handleEditEmpresa}
          onEmpresaDeleted={handleEmpresaDeleted}
        />
      )}
    </Container>
  );
}

export default EmpresasPage;
